// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3y5Gz","newExpiryDate":"styles_newExpiryDate__ga8jd","footer":"styles_footer__1Vm0s"};